<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="formDialogVisible"
    width="800px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="form">
      <el-form ref="form" :model="form" label-width="160px">
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item
              :rules="rules.phoneNum"
              label="手机号"
              prop="phoneNum"
            >
              <el-input
                v-model.trim="form.phoneNum"
                :disabled="newType === 'detail'"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="昵称" prop="nickName">
              <el-input
                v-model.trim="form.nickName"
                :disabled="newType === 'detail'"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="微信OpenID" prop="openid">
              <el-input
                v-model="form.openid"
                :disabled="newType === 'detail'"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="newType !== 'detail'">
          <el-col :span="18">
            <el-form-item
              :rules="newType === 'add' ? rules.password : null"
              label="密码"
              prop="password"
            >
              <el-input
                v-model.trim="form.password"
                :disabled="newType === 'detail'"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="绑定车辆" prop="bindVehicles">
              <el-select
                filterable
                multiple
                v-model="form.bindVehicles"
                placeholder="请选择"
                :disabled="newType === 'detail'"
                size="large"
              >
                <el-option
                  v-for="item in carList"
                  :key="item.id"
                  :label="item.frame_num"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer v-if="newType !== 'detail'">
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm('form')">
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { addAppUser, getAppUserDetail, updateAppUser } from '@/api/customer';
import { FormValidators } from '@/utils/validate';

import { GetCarList } from '@/api/car';
const titleMap = new Map([
  ['add', '新建'],
  ['edit', '编辑'],
  ['detail', '详情'],
]);
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formDialogVisible: false,
      carList: [],
      dialogTitle: '',
      rules: {
        phoneNum: [
          { required: true, message: '请输入手机号!', trigger: 'blur' },
          {
            validator: FormValidators.mobilePhone,
            message: '请输入正确格式手机号！',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入密码!', trigger: 'blur' },
          {
            validator: FormValidators.notChinese,
            message: '密码不允许输入中文!',
            trigger: 'blur',
          },
        ],
      },
      form: {
        phoneNum: '',
        nickName: '',
        openid: '',
        password: '',
        bindVehicles: [],
      },
      newType: '',
    };
  },
  created() {},
  watch: {
    // 显示隐藏双向绑定
    visible(val) {
      this.formDialogVisible = val;
      if (val) {
        this.initFormData();
      }
    },
    formDialogVisible(val) {
      this.$emit('visible-change', val);
    },
    type(val) {
      // 获取类型
      if (val) {
        this.newType = val;
        this.dialogTitle = titleMap.get(val);
      }
    },
  },
  methods: {
    handleClose() {
      this.formDialogVisible = false;
      this.$refs['form'].resetFields();
    },

    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const fn = this.id ? updateAppUser : addAppUser;
          fn(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功!');
              this.handleClose();
              this.$emit('success');
            }
          });
        }
      });
    },
    //非空判断
    isNotEmpty(str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true;
      }
      return false;
    },
    async initFormData() {
      const { data } = await GetCarList({
        start: 1,
        size: 1000,
        is_bind_user: 0,
      });
      this.carList = data.content.map((item) => {
        return {
          id: item.id,
          frame_num: item.frame_num,
        };
      });
      if (this.id) {
        this.getDetail();
      }
    },
    getDetail() {
      getAppUserDetail(this.id).then((res) => {
        if (res.code == 0) {
          const bindCardList = res.data.bindCardList.map((item) => {
            return {
              id: item.carId,
              frame_num: item.frameNum,
            };
          });
          this.carList = this.carList.concat(bindCardList);
          res.data.bindVehicles = res.data.bindCardList.map((item) => {
            return item.carId;
          });
          res.data.password = '';
          this.form = res.data;
        } else {
          let msg = res.message;
          this.$message.error(this.isNotEmpty(msg) ? msg : '查询异常!');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  max-height: 500px;
  overflow-y: scroll;
}
/deep/.el-select,
.el-date-editor {
  width: 100%;
}
</style>
